import React from "react"
import id from "@irati/utils/id"

import "./style.css"

interface Props {
  id?: string
}

const Loader = (props: Props) => <div id={id("loader", props)} className="loader" />

export default Loader
